import React from "react";

import { Navigate } from "react-router-dom";

import Loading from "ds/PageLoading";
import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import getUrl from "Libs/getUrl";
import {
  selectEnableCustomBackupSchedules,
  projectCapabilitySelector,
  selectCapabilitiesAreLoading
} from "Reducers/project/capabilities";

import BackupSchedules from "./BackupSchedules";

const BackupSchedulesNavigator = () => {
  const { organizationId, projectId } = useDecodedParams<{
    organizationId: string;
    projectId: string;
  }>();

  const isCustomBackupSchedulesEnabled = useSelectorWithUrlParams(
    selectEnableCustomBackupSchedules
  );
  const capabilitiesAreLoading = useSelectorWithUrlParams(
    selectCapabilitiesAreLoading
  );
  const projectCapability = useSelectorWithUrlParams(projectCapabilitySelector);

  if (
    (!projectCapability && typeof capabilitiesAreLoading === "undefined") ||
    capabilitiesAreLoading
  ) {
    return <Loading iconOnly />;
  }

  return !isCustomBackupSchedulesEnabled ? (
    <Navigate
      to={getUrl({
        key: "organization.project.settings",
        props: { organizationId, projectId }
      })}
    />
  ) : (
    <BackupSchedules />
  );
};

export default BackupSchedulesNavigator;
